import { DestroyRef, Directive, effect, inject, input, signal } from '@angular/core';

@Directive({
  selector: '[appPulseOnChange]',
  standalone: true,
  host: {
    '[class.sb-change-pulse]': 'isPulsing()'
  }
})
export class PulseOnChangeDirective {
  readonly appPulseOnChange = input(0);

  protected readonly isPulsing = signal(false);

  private readonly destroyRef = inject(DestroyRef);
  private timeoutId: ReturnType<typeof setTimeout> | undefined;

  constructor() {
    effect(() => {
      if (!this.appPulseOnChange()) {
        return;
      }

      this.isPulsing.set(false);
      queueMicrotask(() => this.isPulsing.set(true));

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      this.timeoutId = setTimeout(() => this.isPulsing.set(false), 360);
    });

    this.destroyRef.onDestroy(() => {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
    });
  }
}
